import { useEffect, useState } from 'react'
import { PageHeader } from '../../../shared/components'
import { UserDto } from 'appDtos';
import { Container, ListGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { AdministrationPaths } from '../../../shared/api/constants';
import { AlertComponent } from '../../../shared/components';
import { useApi } from '../../../shared/hooks/useApi';
import { useApiHandleError } from '../../../shared/hooks/useApiHandleError';
import { AppPaths } from '../../../shared/appConstants';
import { Loading } from '../../../shared/components';
import { formatDate } from '../../../shared/utils/utils';

export function Users() {
  const [users, setUsers] = useState<UserDto[]>([]);
  const [loading, setLoading] = useState(true);
  const API = useApi();
  const { setError, errorMessage } = useApiHandleError();
  const goTo = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await API.get(AdministrationPaths.GetUsers());
        if (response.data) {
          setUsers(response.data);
        }
      } catch (error) {
        setError(error)
      }
      setLoading(false);
    }

    if (!users.length) {
      fetch();
    }
  }, [API, users, setError]);

  return (
    <Container className="mb-3">
      <PageHeader pageTitle='Users' navPath={AppPaths.getCreateUser()}/>
      <AlertComponent message={errorMessage} />
      {loading ? (
        <Loading />
      ) : (
        users.length > 0 ?
        <div className="table-responsive">
          <ListGroup as="ol">
            <ListGroup.Item key="top" className="d-none d-md-flex justify-content-spaced-evenly align-items-start">
              <div className="ms-2 me-auto col-2 fw-bold">User</div>
              <div className="ms-2 me-auto col-2 fw-bold d-none d-lg-block">Created Date</div>
              <div className="ms-2 me-auto col-2 fw-bold d-none d-lg-block">Last Login Date</div>
              <div className="ms-2 me-auto col-2 fw-bold d-none d-xl-block">Login Count</div>
              <div className="ms-2 me-auto col-2 fw-bold d-none d-xl-block">Email Confirmed</div>
              <div className="ms-2 me-auto col-2 fw-bold">Status</div>
            </ListGroup.Item>
            {users.map((user,i) => (
              <ListGroup.Item key={i} action as="li" className="d-flex flex-column flex-md-row justify-content-spaced-evenly align-items-start clicable py-2 py-md-3" onClick={() => goTo(AppPaths.getUserDetail(user.id))}>
                <div className="ms-2 me-auto col-12 col-md-2 mb-2 mb-md-0">
                  <div className="fw-bold">{user.firstName} {user.lastName}</div>
                  <small className="text-muted">{user.email}</small>
                </div>
                <div className="ms-2 me-auto col-12 col-md-2 mb-1 mb-md-0 d-none d-lg-block">
                  <small className="d-md-none fw-bold">Created: </small>{formatDate(user.createdDate)}
                </div>
                <div className="ms-2 me-auto col-12 col-md-2 mb-1 mb-md-0 d-none d-lg-block">
                  <small className="d-md-none fw-bold">Last Login: </small>{user.lastLoginDate ? formatDate(user.lastLoginDate): 'N/A'}
                </div>
                <div className="ms-2 me-auto col-12 col-md-2 mb-1 mb-md-0 d-none d-xl-block">
                  <small className="d-md-none fw-bold">Logins: </small>{user.loginsCount}
                </div>
                <div className="ms-2 me-auto col-12 col-md-2 mb-1 mb-md-0 d-none d-xl-block">
                  <small className="d-md-none fw-bold">Email Confirmed: </small>{user.emailConfirmed ? 'YES': 'NO'}
                </div>
                <div className="ms-2 me-auto col-12 col-md-2">
                  <small className="d-md-none fw-bold">Status: </small>
                  <span className={`badge ${user.isActive ? 'bg-success' : 'bg-secondary'}`}>{user.isActive ? 'Active': 'Inactive'}</span>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
        : (
          <AlertComponent message="No user has been created." variant="info"/>
        )
      )}
    </Container>
  );
}
